import PropTypes from "prop-types";
import React from "react";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import Modal from "../../components/Modal";
import "./style.scss";
import BodyText from "../../elements/body-text";

export default function ConfirmationModal({ heading, subHeading, body, button, showModal, warningMessage, onCloseClicked = () => {} }) {
  return (
    <Modal className="confirmation-modal" showModal={showModal} onCloseClicked={onCloseClicked}>
      <div className="confirmation-modal-heading">
        <Heading {...heading} typographyClass="type-h1" />
      </div>
      <div className="confirmation-modal-sub-heading">
        <Heading {...subHeading} typographyClass="type-h3" />
      </div>
      <BodyText html={body} className="confirmation-modal-body" />
      {warningMessage && <div className="failed-message">{warningMessage}</div>}
      <div className="confirmation-modal-button">
        <PrimaryButton {...button} />
      </div>
    </Modal>
  );
}

// ConfirmationModal.propTypes = {
//   heading: PropTypes.object,
//   subHeading: PropTypes.object,
//   body: PropTypes.string,
//   button: PropTypes.object,
//   onCloseClicked: PropTypes.func
// };
